// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3a72ce33","453":"c64155c1","455":"fa3d0653","977":"10c7bc31"}[chunkId] + ".chunk.js";
};